import React, { useEffect, useState } from 'react';
import { API } from '../../../constans/http';
import http from '../../../services/http.service';
import Spinner from '../../UI/Spinner/Spinner';
import { formatCurrency, formatTime, objectIsNotEmpty } from '../../../helpers/helper-methods';
import { facilitiesMap, payedStatus, facilitiesInterval } from '../../../constans/model-maps';
import PropertyRestaurant from '../../PropertyRestaurant/PropertyRestaurant';

import styles from './PropertyInfoTab.module.scss';
import stylesResult from '../PropertyDetailsSearchResult/PropertyDetailsSearchResult.module.scss';
import { NA } from '../../../constans/roomsServices';

function PropertyInfoTab({ propertyId, anchorsData }) {
  const [propertyData, setPropertyData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    if (propertyId) {
      http
        .get(`${API.PROPERTIES}/${propertyId}`)
        .then(({ data }) => {
          setPropertyData(data);
          setLoading(false);
        }).catch(() => setLoading(false));
    }
  }, [propertyId]);
  return (
    <div className={`${styles.detailsWrapper}`}>
      {loading ? (
        <Spinner spinnerClasses="spinner-primary" />
      ) : (
        <>
          {propertyData.facilities || propertyData.keyFacilities ? (
            <div
              id={anchorsData.facilities.id}
              className={styles.infoBlock}
            >
              <div className={styles.infoList}>
                {propertyData.facilities
                                    && propertyData.facilities.length > 0 && (
                                    <div className={styles.infoListItem}>
                                      <div className={styles.infoBlockTitle}>
                                        List of facilities
                                      </div>
                                      {propertyData.facilities.map((facility, item) => (
                                        <div
                                          key={`cowhq${item}`}
                                          className={`${styles.infoListItemDotted} ${styles.mb15}`}
                                        >
                                          <div className={`${styles.mb5} t-500`}>
                                            {facility.title}
                                          </div>
                                          <div className={`${styles.infoBlockText}`}>
                                            {facility.description}
                                          </div>
                                        </div>
                                      ))}
                                    </div>
                )}
                {propertyData.keyFacilities
                  ? objectIsNotEmpty(propertyData.keyFacilities) && (
                    <div className={styles.infoListItem}>
                      <div className={styles.infoBlockTitle}>
                        Parking & Wi-fi
                      </div>
                      {Object.keys(propertyData.keyFacilities).map(
                        (keyfacilityKey, item) => (
                          <div
                            key={`xdvcf${item}`}
                            className={`${styles.infoListItemDotted} ${styles.mb15}`}
                          >
                            <div className={`${styles.mb5} t-500`}>
                              <span
                                className={`${styles.mr5} capitalized-text`}
                              >
                                {facilitiesMap[propertyData
                                  .keyFacilities[keyfacilityKey].status]
                                  ? facilitiesMap[propertyData
                                    .keyFacilities[keyfacilityKey].status]
                                  : propertyData
                                    .keyFacilities[keyfacilityKey].status.toLowerCase()}
                              </span>
                              <span className="lowered-text">
                                {
                                                                    propertyData.keyFacilities[
                                                                      keyfacilityKey
                                                                    ].type
                                                                }
                              </span>
                              {propertyData.keyFacilities[
                                keyfacilityKey
                              ].status === payedStatus && (
                              <>
                                <span
                                  className={styles.subtitleDelimiter}
                                >
                                  -
                                </span>
                                {propertyData.keyFacilities[keyfacilityKey].price
                                                                            && propertyData.keyFacilities[keyfacilityKey].currency.code ? (
                                                                              <span
                                                                                className={`${styles.mr5} ${styles.ml5}`}
                                                                              >
                                                                                {formatCurrency(
                                                                                  propertyData.keyFacilities[keyfacilityKey].currency.code,
                                                                                  propertyData.keyFacilities[keyfacilityKey].price,
                                                                                )}
                                                                              </span>
                                  ) : null}
                                {facilitiesInterval[propertyData
                                  .keyFacilities[keyfacilityKey].interval]}
                              </>
                              )}
                            </div>
                            <div
                              className={`${styles.infoBlockText}`}
                            >
                              {
                                                                propertyData.keyFacilities[
                                                                  keyfacilityKey
                                                                ].description
                                                            }
                            </div>
                          </div>
                        ),
                      )}
                    </div>
                  )
                  : null}
              </div>
            </div>
          ) : null}
          {propertyData.restaurants && (
            <div
              id={anchorsData.restaurants.id}
              className={styles.infoBlock}
            >
              <div className={styles.infoBlockTitle}>
                Food & Beverages
              </div>
              <div
                className={`${styles.foodContainer} ${styles.infoList}`}
              >
                {propertyData.restaurants.map(({ id: restaurantId, ...restaurant }) => (
                  <PropertyRestaurant
                    foodImageStyles={stylesResult.foodImageItem}
                    className={styles.infoListItem}
                    key={restaurantId}
                    {...restaurant}
                  />
                ))}
              </div>
            </div>
          )}

          {propertyData.roomServices && (
            <div
              id={anchorsData.roomServices.id}
              className={`${styles.infoBlock} ${styles.lastBlock}`}
            >
              <div className={styles.infoBlockTitle}>Room service</div>
              <div
                className={`${styles.foodContainer} ${styles.infoList}`}
              >
                {propertyData.roomServices.map((room, index) => (
                  <div
                    className={`${styles.infoListItemDotted} t-500`}
                    key={`sc${index}`}
                  >
                    <div
                      className={`${styles.mb10} ${styles.roomServiceDataTitle} capitalized-text t-500`}
                    >
                      <span>{room.title}</span>
                      {(room.fromTime && room.toTime)
                        ? (
                          <>
                            <span className={styles.subtitleDelimiter}>
                              -
                            </span>
                            <span>{!!room.fromTime && formatTime(room.fromTime)}</span>
                            <span className={styles.subtitleDelimiter}>
                              -
                            </span>
                            <span>{!!room.toTime && formatTime(room.toTime)}</span>
                          </>
                        )
                        : (room.status === NA.value ? (
                          <span>
                            {' '}
                            {NA.label}
                          </span>
                        ) : <span> 24/7</span>)}
                    </div>
                    {room.description && (
                    <div
                      className={`${styles.listItemDescr} ${styles.roomServiceDataDescr}`}
                    >
                      { /* room.description */}
                    </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          )}

          {propertyData.accessibilities
                        || propertyData.accessibilityDescription ? (
                          <div
                            id={anchorsData.accessibilities.id}
                            className={styles.infoBlock}
                          >
                            <div className={styles.infoBlockTitle}>accessibility</div>

                            {propertyData.accessibilities && (
                            <div className={styles.infoList}>
                              {propertyData.accessibilities.map(
                                (accessibilityItem, index) => (
                                  <div
                                    key={`sdfdf${index}`}
                                    className={`${styles.infoListItemDotted} ${styles.infoListItem}`}
                                  >
                                    <div
                                      className={`${styles.listItemTitleMargined} t-500`}
                                    >
                                      {accessibilityItem.title}
                                    </div>
                                    {accessibilityItem.description ? (
                                      <div className={styles.listItemDescr}>
                                        {accessibilityItem.description}
                                      </div>
                                    ) : null}
                                  </div>
                                ),
                              )}
                            </div>
                            )}
                            {propertyData.accessibilityDescription && (
                            <>
                              <div
                                className={`${styles.generalDescr} ${styles.infoBlockSubtitle}`}
                              >
                                accessibility Description
                              </div>
                              <div className={`${styles.infoBlockText}`}>
                                {propertyData.accessibilityDescription}
                              </div>
                            </>
                            )}
                          </div>
            ) : null}
        </>
      )}
    </div>

  );
}

PropertyInfoTab.defaultProps = {
  anchorsData: {
    aboutUs: {
      id: null,
    },
    accessibilities: {
      id: null,
    },
    policies: {
      id: null,
    },
    transports: {
      id: null,
    },
    facilities: {
      id: null,
    },
    restaurants: {
      id: null,
    },
    roomServices: {
      id: null,
    },
  },
};

export default PropertyInfoTab;
